import React, { useEffect, useState } from 'react';
import { useParams, useNavigate, useLocation } from 'react-router-dom';
import Base from '../base';
import { Alert } from '@themesberg/react-bootstrap';
import { post } from '../../services/back.service';
import ModifyFormOrder from '../../components/forms/orders/form.orders';
import ModalMessage from '../../components/widgets/modalMessage';

function EditOrders() {
  const { id } = useParams();
  const navigate = useNavigate();
  const location = useLocation();
  const basePath = location.pathname.split('/order/')[0];
  const [alert, setAlert] = useState({
    show: false,
    message: '',
    type: ''
  });
  const [showModalConvert, setShowModalConvert] = useState(false);
  const [loadingConvert, setLoadingConvert] = useState(false);
  const [orderData, setOrderData] = useState(null);

  const upsertOrder = ({ message, type }) => {
    setAlert({ show: true, message, type });
    if (type === 'success' && id === '0') {
      setTimeout(() => {
        navigate(basePath);
      }, 1500);
    }
  };

  useEffect(() => { }, [id]);

  const handleConvert = async () => {
    setLoadingConvert(true);
    const response = await post(`/orders/${id}/convert/`, {});
    setLoadingConvert(false);

    if (response.success) {
      setAlert({ show: true, message: 'Orden convertida a peritaje exitosamente', type: 'success' });
    } else {
      setAlert({ show: true, message: response.message || 'Error al convertir orden', type: 'danger' });
    }
    setShowModalConvert(false);
  };

  const handleOrderLoaded = (data) => {
    setOrderData(data);
  };

  return (
    <Base>
      {alert.show && (
        <Alert variant={alert.type} onClose={() => setAlert({ show: false })} dismissible>
          {alert.message}
        </Alert>
      )}

      <ModifyFormOrder selectOrder={id} callback={upsertOrder} onOrderLoaded={handleOrderLoaded} />

      <ModalMessage
        title="Confirmar Conversión"
        text={`¿Está seguro que desea convertir la orden #${id} a peritaje?`}
        showProps={showModalConvert}
        funcAccept={handleConvert}
        funcClose={() => setShowModalConvert(false)}
      />
    </Base>
  );
}

export default EditOrders;